import { render, staticRenderFns } from "./classical-upload-resume.vue?vue&type=template&id=f08ab6da"
import script from "./classical-upload-resume.vue?vue&type=script&lang=js"
export * from "./classical-upload-resume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports